import React, { Component } from 'react'
import Link from '../../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { QuoteMark, Close } from '../icons'

class TestimonialCard extends Component {

  render() {

    const { quote, name, location, index, noclick} = this.props

    return (
      <div className='testimonial'>
        <div className='testimonial__details' onClick={() => !noclick && this.props.showLightbox(index)}>
          <QuoteMark color='#91A0C1' />
          <div className='copy' dangerouslySetInnerHTML={{ __html: quote }} />
          <p className='name'>{ name }</p>
          <p className='location'>{ location }</p>
          <span className='read-more'>Read More</span>
        </div>
      </div>
    )
  }
}

export default TestimonialCard
